

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import api from "@/services/api"
import { namespace, Mutation } from "vuex-class"

const caseStore = namespace("cases")

@Component({
	components: {
	}
})
export default class CaseFileDisplay extends Vue {
	@Prop()
	file: any;

	@Prop({ type: Boolean, default: true })
	showDescription!: Boolean;

	@Prop({ type: Boolean, default: false })
	viewOnly!: Boolean

	@caseStore.Mutation
	public setPreviewFile!: (file: any) => void;

	private deleting = false;

	private readonly previewableExtensions: string[] = ["jpg", "jpeg", "png", "gif", "mp4", "mov"]

	// Must match the icons in public/images/fileicons
	private readonly fileIconExtensions: string[] = [
		"avi", "csv", "doc", "docx", "jpg", "mp3", "mp4", "pdf", "png", "ppt", "txt", "xls", "xlsx", "zip"
	]

	private readonly defaultFileIcon = "default"

	public get thumbnailStyle () {
		if (this.showPreview && this.hasThumbnail) {
			return {
				"background-image": "url(" + this.thumbnailPath + ")",
				"min-width": "60px",
				"min-height": "67px"
			}
		} else {
			return {}
		}
	}

	public downloadFile (file: any) {
		if (this.deleting) {
			return
		}

		if (this.showPreview) {
			this.setPreviewFile(file)
		} else {
			let downloadUrl = api.baseUrl + "files/download/" + file.id

			let link = document.createElement("a")
			link.href = downloadUrl
			link.download = downloadUrl
			link.click()
		}
	}

	private get showPreview (): boolean {
		const extension = this.extension(this.file.filename).toLowerCase()
		return this.previewableExtensions.includes(extension)
	}

	private get hasThumbnail (): boolean {
		return this.file.thumbnailPath
	}

	private get thumbnailPath (): string {
		return api.baseUrl + "files/download/" + this.file.id + "?thumbnail=true"
	}

	private extension (filename: string): string {
		return filename.substring(filename.lastIndexOf(".") + 1)
	}

	private fileIconExtension (filename: string): string {
		const extensionName = this.extension(filename).toLowerCase()
		return this.fileIconExtensions.includes(extensionName) ? extensionName : this.defaultFileIcon
	}

	private fileSize (fileSize: number) {
		if (fileSize < 1024) {
			return fileSize + "B"
		}

		fileSize = Math.round(fileSize / 1024)
		if (fileSize < 1024) {
			return fileSize + "KB"
		}

		fileSize = Math.round(fileSize / 1024)
		return fileSize + "MB"
	}

	public async removeFile () {
		this.$emit("removeFile")
	}
}
